var _path, _path2, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 188,
    viewBox: "0 0 208 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.28 124.868C36.5903 180.43 79.7226 189.176 99.3749 186.603C86.781 184.134 70.6681 172.816 64.1859 167.466C50.3572 156.354 41.1381 136.701 38.2572 128.264L32.6833 97.6522L46.8824 47.0294L88.5713 10.9674L132.712 7.88062C143.31 12.6136 164.999 22.018 166.975 21.771C168.605 21.5672 169.507 21.3491 169.888 21.2213C169.972 21.193 169.985 21.0882 169.917 21.0311C136.605 -6.9779 95.2353 -0.0324206 78.6937 6.9541C18.1932 32.6359 15.2094 96.2642 21.28 124.868Z",
    fill: "url(#paint0_linear_87_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9159 31.45C107.519 -5.88981 154.895 15.5845 174.329 31.2057C174.423 31.2817 174.549 31.1883 174.509 31.0737C172.2 24.4605 160.322 16.0536 154.567 12.6205C115.797 -8.61636 79.5588 8.71063 66.2858 20.0287C22.8242 57.0698 29.0389 105.841 37.5789 125.596C56.0995 174.243 102.298 182.083 123.082 179.923C153.95 179.182 170.927 153.685 175.557 141.03C183.753 111.88 172.072 93.5796 165.492 87.6933C165.358 87.5732 165.161 87.7105 165.205 87.8852C170.457 108.79 168.339 121.721 166.605 125.596C151.542 166.835 106.619 160.27 86.041 151.833C70.2368 150.105 48.3826 111.603 39.431 92.5675L52.704 60.7739C57.149 47.1922 66.6973 35.5656 70.9159 31.45Z",
    fill: "#40C32A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_87_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.4594 133.15C34.3816 86.2311 55.7008 40.1356 70.6201 22.9526C26.4178 56.5365 33.4761 105.678 42.5306 126.05C63.0267 166.055 97.3037 175.45 111.88 175.147C134.513 177.048 154.293 167.707 161.371 162.783C153.469 164.511 142.027 165.767 137.294 166.178C111.859 167.166 95.417 159.593 90.3753 155.683C80.2508 149.263 71.5461 137.986 68.4594 133.15Z",
    fill: "#2F19D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_87_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.1233 77.4896C70.4864 78.7581 71.168 80.32 71.168 82.1753V82.7149C71.168 84.4756 70.5432 85.9807 69.2937 87.2302C68.0442 88.4797 66.5391 89.1045 64.7784 89.1045H54.1859V76.2685H64.0685C64.6743 76.2685 64.9772 76.0319 64.9772 75.5586C64.9772 75.161 64.75 74.9243 64.2957 74.8486H51.2041L53.2488 69.1406H59.8939H64.0685C64.9961 69.1406 65.867 69.3583 66.6811 69.7937C67.6088 70.267 68.3566 70.9581 68.9246 71.8668C69.4925 72.7755 69.7765 73.7695 69.7765 74.8486C69.7765 75.7763 69.5588 76.6566 69.1233 77.4896ZM65.9711 83.3965C66.577 83.3965 66.8799 83.1598 66.8799 82.6865C66.8799 82.5918 66.861 82.4972 66.8231 82.4025C66.7284 82.1753 66.5296 82.0333 66.2267 81.9765H59.8939V83.3965H65.9711ZM78.4038 83.3965H88.9963L86.9516 89.1045H72.6957V69.1406H88.9963L86.9516 74.8486H78.4038V76.2685H84.5946L82.5499 81.9765H78.4038V83.3965ZM102.261 69.1406H108.736L102.034 79.1651L101.608 79.8183V89.1045H95.8997V79.6763L95.5589 79.1367L88.7718 69.1406H95.2465L98.7111 74.3374L102.261 69.1406ZM109.856 71.6396C111.9 69.5949 114.362 68.5726 117.239 68.5726C120.136 68.5726 122.607 69.5949 124.651 71.6396C126.696 73.6654 127.718 76.1265 127.718 79.0231C127.718 81.9197 126.696 84.3904 124.651 86.4351C122.607 88.4797 120.136 89.5021 117.239 89.5021C114.362 89.5021 111.9 88.4797 109.856 86.4351C107.811 84.3904 106.789 81.9197 106.789 79.0231C106.789 76.1265 107.811 73.6654 109.856 71.6396ZM117.239 83.51C118.489 83.51 119.549 83.0746 120.42 82.2037C121.31 81.3139 121.755 80.2537 121.755 79.0231C121.755 77.7925 121.31 76.7418 120.42 75.8709C119.549 74.9811 118.489 74.5362 117.239 74.5362C116.009 74.5362 114.958 74.9811 114.087 75.8709C113.216 76.7418 112.781 77.7925 112.781 79.0231C112.781 80.2537 113.216 81.3139 114.087 82.2037C114.958 83.0746 116.009 83.51 117.239 83.51ZM142.078 69.1406H147.786V89.1045H142.078L134.95 79.1367V89.1045H129.242V69.1406H134.95L142.078 79.1367V69.1406ZM166.881 72.0656C168.831 74.0156 169.806 76.3726 169.806 79.1367C169.806 81.8819 168.831 84.2295 166.881 86.1795C164.931 88.1295 162.584 89.1045 159.839 89.1045H152.001V76.2685H157.68V83.3965H159.839C161.012 83.3965 162.016 82.9799 162.849 82.1469C163.682 81.3139 164.098 80.3105 164.098 79.1367C164.098 77.944 163.682 76.9311 162.849 76.0981C162.016 75.2651 161.012 74.8486 159.839 74.8486H148.905L149.842 72.2644L150.95 69.1406H159.839C161.826 69.1406 163.616 69.6517 165.206 70.6741C165.793 71.0717 166.351 71.5355 166.881 72.0656Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_87_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9085 112.678C27.2716 113.947 27.9532 115.509 27.9532 117.364V117.904C27.9532 119.664 27.3284 121.169 26.0789 122.419C24.8294 123.668 23.3243 124.293 21.5636 124.293H10.9711V111.457H20.8536C21.4594 111.457 21.7624 111.221 21.7624 110.747C21.7624 110.35 21.5352 110.113 21.0808 110.037H7.98926L10.0339 104.329H16.6791H20.8536C21.7813 104.329 22.6522 104.547 23.4663 104.982C24.3939 105.456 25.1417 106.147 25.7097 107.056C26.2777 107.964 26.5617 108.958 26.5617 110.037C26.5617 110.965 26.3439 111.845 25.9085 112.678ZM22.7563 118.585C23.3621 118.585 23.665 118.349 23.665 117.875C23.665 117.781 23.6461 117.686 23.6082 117.591C23.5136 117.364 23.3148 117.222 23.0119 117.165H16.6791V118.585H22.7563ZM42.0977 104.329L49.2256 124.293H46.4994H27.8418L29.8865 118.585H41.5013L40.479 115.745L38.5479 110.321L36.5884 115.745L36.1057 117.165H30.3976L34.9697 104.329H42.0977ZM63.0054 104.329H68.7134V124.293H63.0054L55.8774 114.325V124.293H50.1694V104.329H55.8774L63.0054 114.325V104.329ZM82.4126 114.354L89.5405 124.293H83.1226L76.7046 115.745V124.293H70.9966V104.329H76.7046V112.877L83.1226 104.329H89.5405L82.4126 114.354ZM104.727 118.301L110.719 124.293H103.562L97.8543 118.585V124.293H92.1747V112.877H102.142C103.089 112.877 103.562 112.404 103.562 111.457C103.562 110.511 103.089 110.037 102.142 110.037H89.0793L90.0164 107.425L91.124 104.329H102.142C106.894 104.329 109.27 106.705 109.27 111.457C109.27 115.263 107.756 117.544 104.727 118.301ZM122.535 114.751V104.216H128.243V114.751C128.243 121.416 125.384 124.748 119.667 124.748C113.968 124.748 111.119 121.416 111.119 114.751V104.216H116.827V114.751C116.827 117.61 117.774 119.04 119.667 119.04C121.579 119.04 122.535 117.61 122.535 114.751ZM142.132 104.329C146.884 104.329 149.26 106.705 149.26 111.457C149.26 116.209 146.884 118.585 142.132 118.585H137.844V124.293H132.164V112.877H142.132C143.079 112.877 143.552 112.404 143.552 111.457C143.552 110.511 143.079 110.037 142.132 110.037H129.069L130.006 107.453L131.114 104.329H142.132ZM167.654 104.329H169.727L168.79 106.914L167.682 110.037H162.656V124.293H156.948V110.037H149.422L150.359 107.453L151.467 104.329H151.949H167.654ZM178.565 118.585H187.823L186.318 122.788L185.778 124.293H178.565C175.82 124.293 173.472 123.328 171.522 121.397L171.494 121.368C169.544 119.418 168.569 117.071 168.569 114.325C168.569 111.561 169.544 109.204 171.494 107.254C171.626 107.122 171.759 106.989 171.891 106.857C173.766 105.172 175.99 104.329 178.565 104.329H188.192L186.147 110.037H178.565C177.372 110.037 176.359 110.454 175.526 111.287C174.693 112.12 174.277 113.133 174.277 114.325C174.277 115.499 174.693 116.503 175.526 117.336C176.359 118.169 177.372 118.585 178.565 118.585ZM201.37 104.329H207.844L201.142 114.354L200.716 115.007V124.293H195.008V114.865L194.668 114.325L187.88 104.329H194.355L197.82 109.526L201.37 104.329Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_87_2",
    x: 28.9792,
    y: 21.1006,
    width: 139.182,
    height: 166.028,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.93881
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.39543
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_87_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_87_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_87_2",
    x: 43.7959,
    y: 68.5725,
    width: 126.01,
    height: 28.3377,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4.93881,
    dy: 4.93881
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2347
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_87_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_87_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_87_2",
    x: 0.581044,
    y: 104.216,
    width: 207.263,
    height: 27.94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4.93881,
    dy: 4.93881
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2347
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_87_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_87_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_87_2",
    x1: 94.5816,
    y1: 187,
    x2: 134.855,
    y2: 0.728031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2449D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767172,
    stopColor: "#2914C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#2449D6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplogo);
export default __webpack_public_path__ + "static/media/applogo.74e59e782db25774728882d17aee5f2b.svg";
export { ForwardRef as ReactComponent };